import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

const WRAP: React.CSSProperties = {
  minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: '#141517', color: '#fff', fontFamily: 'Roboto, -apple-system, sans-serif',
  padding: 20, textAlign: 'center',
}
const INNER: React.CSSProperties = { maxWidth: 420 }
const H1: React.CSSProperties = {
  fontFamily: 'Bricolage Grotesque, sans-serif', fontWeight: 600, fontSize: 24, margin: '0 0 8px',
}
const P: React.CSSProperties = { color: 'rgba(255,255,255,0.66)', fontSize: 14, margin: 0 }

interface Props { children: ReactNode }
interface State { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('App error boundary caught:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={WRAP}>
          <div style={INNER}>
            <h1 style={H1}>Something went wrong</h1>
            <p style={P}>An unexpected error occurred. Try reloading the page.</p>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
